export default __webpack_public_path__ + "static/media/404.75512822.svg";